exports.strings = {
    "accept": "Accepter",
    "complete": "Complet",
    "cookiesMessage": "Nous utilisons des cookies pour vous garantir la meilleure expérience possible. Si vous continuez à utiliser cette application, vous consentez à l'utilisation de cookies.",
    "decline": "Déclin",
    "geolocationMessage": "Cette application nécessite des services de localisation qui ne sont pas disponibles. Veuillez activer les services de localisation et actualiser cette page pour continuer.",
    "restartFromBeginning": "Recommencer depuis le début",
    "resumingSession": "Reprise de la session...",
    "reviewAndSubmit": "Réviser et soumettre",
    "submit": "Soumettre",
    "support": "Signaler un problème",
    "termsOfService": "Conditions d'utilisation",
    "termsOfServiceURL": "https://www.attestiv.com/legal/terms-of-service-fr",
    "verificationMessage": "Je certifie que toutes les informations que j'ai fournies sont vraies et correctes au meilleur de mes connaissances. J'accepte également les ",

    // location accuracies
    "locationAccuracy": "Précision de localisation",
    "acceptable": "Acceptable",
    "fair": "Équitable",
    "good": "Bien",
    "great": "Super",
    "outstanding": "Remarquable",
    "poor": "Pauvre",

    // CaptureCamera.js
    "mediaCaptured": "Les médias ont été capturés."
};
